import { Component, OnInit } from '@angular/core';
import { TestRequestService } from '../../services/test-request.service';
//import { Observable } from 'rxjs/Observable';
import { TestRequest } from '../../models/TestRequest';
import { HelperService } from '../../services/helper.service';
import { Router } from '@angular/router';
//import { TestAccession } from '../../models/TestAccession';
import { RequestListFilterComponent } from '../request-list-filter/request-list-filter.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-requests-list',
  standalone: true,
  imports: [RequestListFilterComponent, DatePipe],
  templateUrl: './requests-list.component.html',
  styleUrl: './requests-list.component.css'
})

export class RequestsListComponent implements OnInit {
  TestRequests: TestRequest[] = [];

  constructor(private testRequestService: TestRequestService,
    private helperSerivce: HelperService,
    private router: Router) {
  }

  ngOnInit() {

  }
  delete(testReuest : any) {
    console.log(testReuest);
    this.testRequestService.deleteTestRequest(testReuest.Id).subscribe(data => {
      this.TestRequests = this.helperSerivce.Without(this.TestRequests, (item : any)  => { return item.Id == testReuest.Id; })
    });
  }

  onFilter(data : any) {
    this.loadTestRequest(data);
  }
  private loadTestRequest(searchCriteria : any) {
    this.testRequestService.getTestRequests(searchCriteria).subscribe(data => { this.TestRequests = data; });
  }

  viewDetails(testRequest : any) {
    this.router.navigate(['manage/request-details'], { queryParams: { id: testRequest.Id } });
  }
}
